import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Corrected import
import router from '@/router'; // Import Vue Router

const axiosPlugin = {
    install: (app) => {
        axios.interceptors.request.use(
            async (config) => {
                let retryCount = 0;
                const MAX_RETRIES = 3;
                const token = localStorage.getItem('token');
                if (token) {
                    const decodedToken = jwtDecode(token); // Use jwtDecode
                    const isExpired = decodedToken.exp * 1000 < Date.now();

                    if (isExpired) {
                        if (retryCount >= MAX_RETRIES) {
                            // Reset dan redirect ke login
                            retryCount = 0;
                            localStorage.removeItem('token');
                            router.push('/login');
                            return Promise.reject(new Error('Token refresh retry limit exceeded'));
                        }
                        retryCount++;
                        try {
                            const refreshToken = localStorage.getItem('refresh_token');
                            const refreshResponse = await axios.post(
                                `${process.env.VUE_APP_API_BASE_URL}/api/token/refresh/`,
                                { refresh: refreshToken }
                            );

                            const newAccessToken = refreshResponse.data.access;
                            localStorage.setItem('token', newAccessToken);

                            config.headers.Authorization = `Bearer ${newAccessToken}`;
                        } catch (refreshError) {
                            console.error('Token refresh failed:', refreshError);
                            localStorage.removeItem('token');
                            localStorage.removeItem('refresh_token');
                            router.push('/login'); // Use router to redirect
                            return Promise.reject(refreshError);
                        }
                    } else {
                        config.headers.Authorization = `Bearer ${token}`;
                    }
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Optionally, you can make axios available globally:
        app.config.globalProperties.$axios = axios;  // Access as this.$axios in components
    }
};

export default axiosPlugin;